import { Grid3X3 } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface GridToggleProps {
  showGrid: boolean;
  onToggle: (value: boolean) => void;
}

export function GridToggle({ showGrid, onToggle }: GridToggleProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onToggle(!showGrid)}
            className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
              showGrid ? 'opacity-100' : 'opacity-30'
            }`}
            aria-label="Toggle Grid"
          >
            <Grid3X3 className="h-4 w-4 text-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="flex items-center gap-2 border-border bg-background text-foreground"
        >
          <span>Grid</span>
          <kbd className="rounded border border-border bg-muted px-1 font-mono text-xs text-muted-foreground">
            G
          </kbd>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
